import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { useState } from "react";
import { Badge, CloseButton } from "react-bootstrap";
import { BsBell } from "react-icons/bs";
import { FaRegBell } from "react-icons/fa";
import { VscClose } from "react-icons/vsc";
import "./style.css";
import Fontstyling from "../comman";
import theme from "../../../Utils/theme";
import { useSelector } from "react-redux";
import { clearNotification } from "../../../api/User/commonApi";
import { GetUserDetail } from "../../../api/User/Auth/welcomeApi";
import { updateUserDetail } from "../../../Redux/Reducer/UserDetailsReducer";
import { useDispatch } from "react-redux";
import { ServiceRequests } from "../../../Utils/constants";

function Notification({ data, setData, getNotification, navigate }) {
  const user = useSelector((state) => state.userDetails.value);
  const dispatch = useDispatch();
  const handelClearAll = async () => {
    let payload = {
      notifID: 0,
      notifUserID: user?.UD_id,
      notifClearByID: user?.UD_id,
      notifClearLoginUserStatus: user?.UserRole === "User" ? 2 : 1,
      notifIsClearALL: 1,
    };
    await clearNotification(payload);
    getNotification();
    document.body.click();
  };

  const handelClear = async (notifId, userId) => {
    let payload = {
      notifID: notifId,
      notifUserID: userId,
      notifClearByID: user?.UD_id,
      notifClearLoginUserStatus: user?.UserRole === "User" ? 2 : 1,
      notifIsClearALL: 0,
    };
    await clearNotification(payload);
    getNotification();
    if (data?.length === 1) {
      document.body.click();
    }
  };

  const handleRedirect = (item) => {
    handelClear(item.NotifID, item.UserID);
    document.body.click();
    if (item.ServiceReqID === ServiceRequests.RegionRequest) {
      user?.UserRole !== "User"
        ? navigate("/Admin/servicerequestview")
        : navigate("/servicerequest/regionrequest");
    } else if (item.ServiceReqID === ServiceRequests.ClinicalIntake) {
      if (user?.UserRole !== "User") {
        navigate("/Admin/clinicalintakerequest");
      } else {
        GetUserDetaildata("clinicalIntake/SBAR");
      }
    } else if (item.ServiceReqID === ServiceRequests.EmpoweRx) {
      if (user?.UserRole !== "User") {
        navigate("/Admin/Empowerxaccess");
      } else {
        if (item.NotifTypeName === "Approve") {
          GetUserDetaildata("/EmpoweRx");
        } else {
          GetUserDetaildata("/servicerequest/EmpoweRxRequest");
        }
      }
    } else if (item.ServiceReqID === ServiceRequests.SBARRequest) {
      if (user?.UserRole === "Admin" || user?.UserRole === "Clinician") {
        navigate("/clinicalIntake/SBARIntakeRequest");
      }
    } else if (item.ServiceReqID === ServiceRequests.MarketScanMgmt) {
      if (user?.UserRole === "Admin") {
        navigate("/Admin/MarketScanManagement");
      } else {
        if (item.NotifTypeName === "Approve") {
          GetUserDetaildata("/EmpoweRx/RxBlockPricing/OpenUpdatePeriod");
        } else {
          GetUserDetaildata("/servicerequest/MarketScanMgmtRequest");
        }
      }
    }
  };

  const GetUserDetaildata = async (url) => {
    let payload = {
      UD_emp_email: user?.UD_emp_email,
    };
    await GetUserDetail(payload)
      .then((res) => {
        if (res?.status === 200 || res?.status === 204) {
          dispatch(updateUserDetail(res.data));
          if (url) {
            navigate(url);
          }
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          navigate("/");
        }
      });
  };

  return (
    <>
      <OverlayTrigger
        trigger="click"
        placement={"bottom"}
        rootClose={true}
        overlay={
          <Popover size="xl" id={`popover-positioned-bottom`} className="w-50">
            <Popover.Header as="h3" className="d-flex justify-content-between">
              Notifications
              <span
                onClick={() => document.body.click()}
                style={{ cursor: "pointer", fontSize: "18px" }}
              >
                <VscClose />
              </span>
            </Popover.Header>
            <Popover.Body className="p-0 m-0">
              <div
                className="px-3 overflow-auto"
                style={{
                  maxHeight: "400px",
                  height: "400px",
                }}
              >
                {data?.length ? (
                  data.map((item, i) => (
                    <div
                      className="d-flex align-items-center justify-content-between py-3 border-bottom"
                      key={i}
                    >
                      <div
                        className="text-wrap cursor-pointer"
                        style={Fontstyling.primaryparagraph}
                        onClick={() => handleRedirect(item)}
                      >
                        {item.NotifText}
                      </div>
                      <CloseButton
                        onClick={() => handelClear(item.NotifID, item.UserID)}
                        style={{ cursor: "pointer", fontSize: "10px" }}
                      />
                    </div>
                  ))
                ) : (
                  <div
                    className="text-nowrap text-center mt-5"
                    style={Fontstyling.heading}
                  >
                    No new notifications
                  </div>
                )}
              </div>

              <div className="p-2 text-center">
                <Button
                  className="mt-3 w-100"
                  style={Fontstyling.savebutton}
                  onClick={handelClearAll}
                  disabled={data?.length ? false : true}
                >
                  Clear {data?.length > 1 ? "all" : null}
                </Button>
              </div>
            </Popover.Body>
          </Popover>
        }
      >
        <Button className="btn bg-transparent text-black border-0 position-relative p-0 m-0">
          <FaRegBell size={18} />
          {data?.length ? (
            <Badge
              pill
              className="p-1"
              style={{ top: "-10px", left: "-9px", fontSize: "8px" }}
            >
              {data?.length}
            </Badge>
          ) : null}
        </Button>
      </OverlayTrigger>
    </>
  );
}

export default Notification;
